var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t("checklist.form.Own")))]),_c('success-fade-alert',{ref:"alert",attrs:{"msg":"Formulário exluido com sucesso"}}),_c('fade-alert-danger',{ref:"danger",attrs:{"msg":"Formulário não exluido"}})],1),_c('div',[_c('own',{attrs:{"moduleId":'0'}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }